<template>
  <div class="jeMengagePage-container col-sm-12">
    <div class="jeMengagePage">
      <div
        v-if="submitted && erreurJeMengage != null"
        class="alert alert-danger text-left global-errors"
      >
        <p>
          {{ erreurJeMengage }}
        </p>
      </div>

      <div
        v-if="erreurGlobale != null"
        class="alert alert-danger text-left global-errors mb-5"
      >
        <p>
          {{ erreurGlobale }}
        </p>
      </div>

      <!-- AUTORISATION PARENTALE ET DOPAGE -->
      <div v-if="getAge() < 18" class=" jeMengageDopage mt-5">
        <div
          v-if="!preinscription_out.data.typesPratique.includes('M')"
          class="row title"
        >
          {{ "je_mengage_dopage" | translate(locale) }}
        </div>
        <div
          v-if="preinscription_out.data.typesPratique.includes('M')"
          class="row title"
        >
          {{ "je_mengage_dopage_MB" | translate(locale) }}
        </div>
        <p class="mes-justificatifs-text mt-3" style="font-style: italic">
          {{ "je_mengage_dopage_part_1" | translate("fr") }}
          <input
            class="input ml-1 mr-1"
            type="text"
            placeholder="Nom"
            v-model="preinscription_out.data.generalite.nomRepresentantLegal"
          />
          <input
            class="input ml-1 mr-1"
            type="text"
            placeholder="Prénom"
            v-model="preinscription_out.data.generalite.prenomRepresentantLegal"
          />
          {{ "je_mengage_dopage_part_2" | translate("fr") }}
          <input
            class="input ml-1 mr-1"
            type="text"
            placeholder="Nom"
            v-model="nomLicencie"
          />
          <input
            class="input ml-1 mr-1"
            type="text"
            placeholder="Prénom"
            v-model="prenomLicencie"
          />
          {{ "je_mengage_dopage_part_3" | translate("fr") }}
        </p>
        <p
          v-if="!preinscription_out.data.typesPratique.includes('M')"
          class="mes-justificatifs-text mt-3"
        >
          {{ "je_mengage_dopage_part_4" | translate("fr") }}
        </p>

        <div
          v-if="!preinscription_out.data.typesPratique.includes('M')"
          class="dopage-radio-group"
        >
          <label class="mes-justificatifs-text mt-4"
            ><input
              type="radio"
              id="autorise"
              value="true"
              v-model="
                preinscription_out.data.generalite.autorisationPrelevement
              "
            />
            {{ "je_mengage_dopage_autorise" | translate("fr") }}</label
          >

          <label class="mes-justificatifs-text mt-4"
            ><input
              type="radio"
              id="refuse"
              value="false"
              v-model="
                preinscription_out.data.generalite.autorisationPrelevement
              "
            />
            {{ "je_mengage_dopage_refuse" | translate("fr") }}</label
          >
        </div>
        <p
          v-if="!preinscription_out.data.typesPratique.includes('M')"
          class="mes-justificatifs-text mt-3"
          style="font-style: normal"
        >
          {{ "je_mengage_dopage_part_5" | translate("fr") }}
        </p>
      </div>

      <!-- COMMUNICATION AVEC LA FFBB -->
      <div class="jeMengageCommunication mt-5">
        <div class="row title">
          {{ "je_mengage_communication" | translate(locale) }}
        </div>

        <label class="mes-justificatifs-text mt-4"
          ><input
            type="checkbox"
            class="modal-check-label"
            v-model="preinscription_out.data.generalite.offreCommercialeFFBB"
          />
          {{ "je_mengage_communication_1" | translate("fr") }}</label
        >

        <label class="mes-justificatifs-text mt-4"
          ><input
            type="checkbox"
            class="modal-check-label"
            v-model="
              preinscription_out.data.generalite.offreCommercialePartenaire
            "
          />
          {{ "je_mengage_communication_2" | translate("fr") }}</label
        >

        <p class="text-info-engagement mt-4">
          {{ "je_mengage_communication_text_info" | translate(locale) }}
        </p>

        <p class="mes-justificatifs-text mt-3" style="font-style: italic">
          {{ "je_mengage_finalise_text" | translate("fr") }}
        </p>

        <p
          v-if="
            preinscription_out.data.typesPratique.includes('D') ||
              preinscription_out.data.typesPratique.includes('E') ||
              preinscription_out.data.typesPratique.includes('A') ||
              preinscription_out.data.typesPratique.includes('O')
          "
          class="mes-justificatifs-text mt-3"
          style="font-style: italic"
        >
          {{ "je_mengage_finalise_text_type_pratique" | translate("fr") }}
        </p>

        <p
          v-if="
            preinscription_out.data.typesPratique.includes('D') ||
              preinscription_out.data.typesPratique.includes('E') ||
              preinscription_out.data.typesPratique.includes('A') ||
              preinscription_out.data.typesPratique.includes('O')
          "
          class="mes-justificatifs-text mt-3"
          style="font-style: italic"
        >
          {{ "je_mengage_finalise_text_condamnation" | translate("fr") }}
        </p>
      </div>

      <!-- JE FINALISE MA DEMANDE DE LICENCE -->
      <div class="mt-5">
        <div class="row title">
          {{ "je_mengage_finalise" | translate(locale) }}
        </div>
        <div v-if="getAge() < 18">
          <p class="mes-justificatifs-text mt-3" style="font-style: italic">
            {{ "je_mengage_dopage_part_1" | translate("fr") }}
            <input
              class="input ml-1 mr-1"
              type="text"
              placeholder="Nom"
              v-model="preinscription_out.data.generalite.nomRepresentantLegal"
            />
            <input
              class="input ml-1 mr-1"
              type="text"
              placeholder="Prénom"
              v-model="
                preinscription_out.data.generalite.prenomRepresentantLegal
              "
            />
            {{ "je_mengage_dopage_part_2" | translate("fr") }}
            <input
              class="input ml-1 mr-1"
              type="text"
              placeholder="Nom"
              v-model="nomLicencie"
            />
            <input
              class="input ml-1 mr-1"
              type="text"
              placeholder="Prénom"
              v-model="prenomLicencie"
            />
            {{ "je_mengage_finalise_part_3" | translate("fr") }}
          </p>
        </div>
        <div v-if="getAge() >= 18">
          <p class="mes-justificatifs-text mt-3" style="font-style: italic">
            {{ "je_mengage_dopage_part_1" | translate("fr") }}
            <input
              class="input ml-1 mr-1"
              type="text"
              placeholder="Nom"
              v-model="nomLicencie"
            />
            <input
              class="input ml-1 mr-1"
              type="text"
              placeholder="Prénom"
              v-model="prenomLicencie"
            />
            {{ "je_mengage_finalise_part_3" | translate("fr") }}
          </p>
        </div>
        <div
          class="jeMengageFinalise mt-4"
          v-if="
            preinscription_out.data.licence.id === null ||
              !preinscription_out.data.isLicenceActiveSaisonPasse
          "
        >
          <p class="mes-justificatifs-text mt-3">
            {{ "je_mengage_finalise_pratique_etranger" | translate("fr") }}
          </p>
          <div class="pratique_etranger-radio-group">
            <label class="mes-justificatifs-text"
              ><input
                type="radio"
                id="pratiqueEtrangerOui"
                value="true"
                v-model="preinscription_out.data.generalite.pratiqueEtranger"
              />
              {{ "reponse_oui" | translate("fr") }}</label
            >

            <label class="mes-justificatifs-text"
              ><input
                type="radio"
                id="pratiqueEtrangerNon"
                value="false"
                v-model="preinscription_out.data.generalite.pratiqueEtranger"
              />
              {{ "reponse_non" | translate("fr") }}</label
            >
          </div>
        </div>
      </div>

      <!-- COMMENTAIRE CLUB -->
      <div
        v-if="
          preinscription.data.generalite.commentaireClub != null &&
            preinscription.data.generalite.commentaireClub != ''
        "
        class="mt-5"
      >
        <div class="row title mb-4">
          {{ "je_mengage_commentaire_club" | translate(locale) }}
        </div>

        <p
          class="mes-justificatifs-text commentaire-club mb-0"
          style="font-style: normal"
        >
          {{ preinscription.data.generalite.commentaireClub }}
        </p>
      </div>

      <!-- DOCUMENTS CLUB -->
      <div v-if="documentsClub && documentsClub.length > 0" class="mt-5">
        <div class="row title mb-4">
          {{ "je_mengage_documents_club" | translate(locale) }}
        </div>

        <p class="mes-justificatifs-text" style="font-style: normal">
          {{ "je_mengage_documents_club_texte" | translate(locale) }}
        </p>

        <div class="mes-justificatifs">
          <div
            v-for="documentClub in this.documentsClub"
            :key="documentClub.index"
          >
            <document-club
              :document-titre="documentClub.nom"
              :document-club="documentClub"
            >
            </document-club>
          </div>
        </div>
      </div>

      <!-- JE SÉLECTIONNE MON MODE PAIEMENT -->
      <div class="mt-5 jeMengagePaiement">
        <div class="row title mb-4">
          {{ "je_mengage_mode_paiement" | translate(locale) }}
        </div>

        <div style="text-align: left;">
          <div
            class="pb-4"
            v-if="
              tableauPrixLicencie &&
                tableauPrixLicencie !== 'undefined' &&
                tableauPrixLicencie.length > 0
            "
          >
            <p class="montantText">
              {{ "je_mengage_montant" | translate(locale) }}
              {{ preinscription.data.saison.libelle.toLowerCase() }} :
            </p>
            <div
              v-for="(prixLicencie, index) in this.tableauPrixLicencie"
              :key="index"
              class="row montantText listePrixLicencie pl-3"
              style="display: table;"
            >
              <div class="p-0">{{ prixLicencie.value1 }} :</div>
              <div
                class="montantTextBold p-0"
                style="margin-left: 0; text-align: right; display: table-cell;"
              >
                {{ prixLicencie.value2 }}
              </div>
            </div>
          </div>
          <div
            class="row pb-2 pl-3"
            v-if="
              tableauPrixLicencie &&
                tableauPrixLicencie !== 'undefined' &&
                tableauPrixLicencie.length === 0
            "
          >
            <p class="montantText">
              {{ "je_mengage_montant" | translate(locale) }}
              {{ preinscription.data.saison.libelle.toLowerCase() }} :
            </p>
            <p class="montantTextBold">
              {{ "je_mengage_montant_pas_fourni" | translate(locale) }}
            </p>
          </div>
        </div>

        <div class="card-group-paiement">
          <je-mengage-mode-paiement
            v-if="isPaiementEnLigneDisponible"
            paiement-id="L"
            paiement-titre="RÈGLEMENT PAR CARTE BANCAIRE 100% SÉCURISÉ"
            :paiement-liste="listePaiementL"
            :active-paiement="activePaiement"
            @onUpdatePaiement="updateActivePaiement"
          ></je-mengage-mode-paiement>
          <je-mengage-mode-paiement
            v-if="isPaiementEnLigne3xDisponible"
            paiement-id="L3"
            paiement-titre="RÈGLEMENT PAR CARTE BANCAIRE 100% SÉCURISÉ EN 3 FOIS SANS FRAIS"
            :paiement-liste="listePaiementL"
            :active-paiement="activePaiement"
            @onUpdatePaiement="updateActivePaiement"
          ></je-mengage-mode-paiement>
          <je-mengage-mode-paiement
            paiement-id="C"
            paiement-titre="AUTRE MOYEN DE PAIEMENT"
            :active-paiement="activePaiement"
            @onUpdatePaiement="updateActivePaiement"
          ></je-mengage-mode-paiement>
        </div>

        <div
          v-if="this.activePaiement === 'L' || this.activePaiement === 'L3'"
          class="row"
        >
          <p
            class="mes-justificatifs-text"
            style="font-style: normal; color: rgb(220, 53, 69)"
          >
            {{ "je_mengage_notice_paiement" | translate(locale) }}
          </p>
        </div>
      </div>

      <div
        v-if="submitted && erreurJeMengage != null"
        class="alert alert-danger text-left global-errors mt-5"
      >
        <p>
          {{ erreurJeMengage }}
        </p>
      </div>

      <div
        v-if="erreurGlobale != null"
        class="alert alert-danger text-left global-errors mb-5"
      >
        <p>
          {{ erreurGlobale }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import JeMengageModePaiement from "@/components/general/JeMengageModePaiement.vue";
import DocumentClub from "@/components/general/DocumentClub.vue";
import preinscriptionAppelsServeur from "@/preinscriptionUtils";
import translations from "@/Translations.js";

export default {
  components: {
    JeMengageModePaiement,
    DocumentClub
  },
  props: {
    preinscription: Object,
    token: undefined,
    locale: {
      type: String,
      default: "fr"
    }
  },
  data() {
    return {
      preinscription_out: Object,
      erreurGlobale: null, // valorisée dans traitementErreursServeur
      nomLicencie: "",
      prenomLicencie: "",
      submitted: false,
      erreurJeMengage: null,
      token_out: undefined,
      activePaiement: "",
      listePaiementL: ["carte-bleue", "visa", "mastercard"],
      tableauPrixLicencie: undefined,
      isPaiementEnLigneDisponible: false,
      isPaiementEnLigne3xDisponible: false,
      documentsClub: undefined,
      prixTotal: null
    };
  },
  methods: {
    canContinue() {
      this.submitted = true;
      this.validationPage();
    },
    validationPage() {
      this.erreurJeMengage = null;

      if (
        this.getAge() < 18 &&
        !this.preinscription_out.data.typesPratique.includes("M") &&
        (this.preinscription_out.data.generalite.nomRepresentantLegal ===
          null ||
          this.preinscription_out.data.generalite.nomRepresentantLegal === "" ||
          this.preinscription_out.data.generalite.prenomRepresentantLegal ===
            null ||
          this.preinscription_out.data.generalite.prenomRepresentantLegal ===
            "" ||
          this.nomLicencie === "" ||
          this.prenomLicencie === "" ||
          this.preinscription_out.data.generalite.autorisationPrelevement ===
            null)
      ) {
        this.erreurJeMengage =
          "Il est nécessaire de remplir tous les champs modifiables et choisir une option dans la partie AUTORISATION PARENTALE ET DOPAGE pour pouvoir continuer";
        this.$emit("can-continue", { value: false });
      } else if (
        this.getAge() < 18 &&
        this.preinscription_out.data.typesPratique.includes("M") &&
        (this.preinscription_out.data.generalite.nomRepresentantLegal ===
          null ||
          this.preinscription_out.data.generalite.nomRepresentantLegal === "" ||
          this.preinscription_out.data.generalite.prenomRepresentantLegal ===
            null ||
          this.preinscription_out.data.generalite.prenomRepresentantLegal ===
            "" ||
          this.nomLicencie === "" ||
          this.prenomLicencie === "")
      ) {
        this.erreurJeMengage =
          "Il est nécessaire de remplir tous les champs modifiables pour pouvoir continuer";
        this.$emit("can-continue", { value: false });
      } else if (
        this.getAge() >= 18 &&
        (this.nomLicencie === "" || this.prenomLicencie === "")
      ) {
        this.erreurJeMengage =
          "Il est nécessaire de remplir tous les champs modifiables pour pouvoir continuer";
        this.$emit("can-continue", { value: false });
      } else if (
        this.preinscription_out.data.generalite.pratiqueEtranger === null &&
        (this.preinscription_out.data.licence.id === null ||
          !this.preinscription_out.data.isLicenceActiveSaisonPasse)
      ) {
        this.erreurJeMengage =
          "Il est obligatoire d'apporter une réponse dans la partie JE FINALISE MA DEMANDE DE LICENCE pour pouvoir continuer";
        this.$emit("can-continue", { value: false });
      } else if (this.activePaiement === null || this.activePaiement === "") {
        this.erreurJeMengage = "Veuillez sélectionner un moyen de paiement";
        this.$emit("can-continue", { value: false });
      } else if (
        this.activePaiement === "L3" &&
        this.prixTotal != null &&
        parseFloat(this.prixTotal) < 1
      ) {
        this.erreurJeMengage =
          "Le montant est trop faible pour autoriser un paiement en plusieurs fois";
        this.$emit("can-continue", { value: false });
      } else {
        this.preinscription_out.data.generalite.paiementEnLigne = this.activePaiement;

        this.$emit("can-continue", {
          value: true,
          preinscription: this.preinscription_out
        });
      }
    },
    getAge() {
      if (!this.preinscription_out.data) {
        return 0;
      }
      var dateNaissance = this.preinscription_out.data.dateNaissance;
      var dateFinSaison = this.preinscription_out.data.saison.fin;
      return preinscriptionAppelsServeur.getAgeLicencie(
        dateNaissance,
        dateFinSaison
      );
    },
    updateActivePaiement(paiement) {
      this.activePaiement = paiement;
    },
    formatMontant(montant) {
      // format montant au format français ###,##
      return preinscriptionAppelsServeur.formatMontant(montant);
    },
    getDocumentsClub(isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getDocumentsClub(this.token_out)
        .then(result => {
          that.documentsClub = result.data;
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getDocumentsClub,
            argsArray
          );
        });
    },
    getTableauPrixLicencie(isReconnected) {
      var that = this;
      preinscriptionAppelsServeur
        .getTableauPrixLicencie(this.token_out)
        .then(result => {
          that.tableauPrixLicencie = result.data;
          if (that.tableauPrixLicencie.length > 0) {
            var index;
            for (index = 0; index < that.tableauPrixLicencie.length; index++) {
              that.tableauPrixLicencie[index].value2 = that.formatMontant(
                that.tableauPrixLicencie[index].value2
              );
              if (that.tableauPrixLicencie[index].value1 === "Total") {
                that.prixTotal = that.tableauPrixLicencie[index].value2;
              }
              if (
                that.tableauPrixLicencie[index].value1 === "Total" &&
                that.tableauPrixLicencie[index].value2 != "0,00"
              ) {
                that.isPaiementEnLigneDisponible = true;
                // on affiche la case 3x sans frais que si paiement3x = true
                if (that.preinscription_out.data.paiement.paiement3x === true) {
                  that.isPaiementEnLigne3xDisponible = true;
                }
              }
              if (that.tableauPrixLicencie[index].value1 === "Remise %") {
                that.tableauPrixLicencie[index].value2 =
                  that.tableauPrixLicencie[index].value2 + " %";
              } else {
                that.tableauPrixLicencie[index].value2 =
                  that.tableauPrixLicencie[index].value2 + " €";
              }
            }
          }
        })
        .catch(error => {
          // a rajouter les arguments de la methode(sauf isReconnected), si necessaire ex: argsArray.push(arg1);
          var argsArray = [];
          preinscriptionAppelsServeur.traitementErreursServeur(
            error,
            isReconnected,
            that,
            that.getTableauPrixLicencie,
            argsArray
          );
        });
    }
  },
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  watch: {
    token: function() {
      if (this.token) {
        this.token_out = JSON.parse(JSON.stringify(this.token));
      }
    }
  },
  created() {
    // la clone preinscription_out est utilisé dans le template et il faut l'initialiser avant mounted
    this.preinscription_out = JSON.parse(JSON.stringify(this.preinscription));

    // la clone token_out est utilisée pour pouvoir mettre a jour le token si la session a expiré (on peut pas modifier directement un prop)
    if (this.token) {
      this.token_out = JSON.parse(JSON.stringify(this.token));
    }
  },
  mounted() {
    this.getDocumentsClub(false /*isReconnected*/);
    if (
      this.preinscription_out.data.paiement != null &&
      this.preinscription_out.data.paiement.validation === true
    ) {
      this.getTableauPrixLicencie(false /*isReconnected*/);
    } else {
      this.tableauPrixLicencie = [];
    }

    // clone le nom et prenom de la préinscription
    this.nomLicencie = JSON.parse(
      JSON.stringify(this.preinscription_out.data.nom)
    );
    this.prenomLicencie = JSON.parse(
      JSON.stringify(this.preinscription_out.data.prenom)
    );

    this.activePaiement = JSON.parse(
      JSON.stringify(this.preinscription_out.data.generalite.paiementEnLigne)
    );

    this.$emit("can-continue", { value: false });
  }
};
</script>

<style scoped>
.input {
  padding: 5px 10px;
  border: solid 1px #6c757d2b !important;
}
.jeMengageDopage label,
.jeMengageCommunication label,
.jeMengageFinalise label,
.jeMengagePaiement label {
  display: block;
  padding-left: 35px;
  text-indent: -35px;
}
.jeMengageDopage label input,
.jeMengageCommunication label input,
.jeMengageFinalise label input,
.jeMengagePaiement label input {
  vertical-align: bottom;
  margin-right: 10px;
}

.text-info-engagement {
  text-align: left;
  font-family: Lato;
  font-size: 9px;
  color: #000000;
  white-space: pre-line;
}

.commentaire-club {
  white-space: pre-wrap;
}

.montantText {
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  color: #000000;
}

.montantTextBold {
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  margin-left: 10px;
}

.mes-justificatifs {
  display: flex;
  flex-flow: row wrap;
}

.listePrixLicencie {
  width: 40%;
}

/* laptops & desktops */
@media (min-width: 1025px) {
  .jeMengagePage {
    margin: 3rem 8rem;
  }

  .listePrixLicencie {
    width: 40%;
  }
}

/* mobile phone */
@media (max-width: 480px) {
  .jeMengagePage {
    margin: 10px 15px;
  }

  .input {
    margin: 3px 0;
  }

  .montantText,
  .montantTextBold {
    font-size: 13px;
  }

  .mes-justificatifs {
    display: inline-grid;
  }

  .listePrixLicencie {
    width: 100%;
  }
}

/* tablet */
@media (min-width: 481px) and (max-width: 1024px) {
  .jeMengagePage {
    margin: 3rem 3rem;
  }

  .listePrixLicencie {
    width: 70%;
  }
}
</style>
